import * as z from "zod";

export const deleteGoldenDomeNotification = {
  name: "deleteGoldenDomeNotification" as const,
  input: z.object({ id: z.string() }),
  output: z.object({}),
};
